'use client'

import {
  apartmentFeatureIconComponents,
  type ApartmentFeatureId,
} from '@/lib/apartments/apartmentFeatureOptions'
import { useMessages } from '@/lib/i18n/useMessages'

import { RoomDetailIconList, RoomDetailIconListItem } from '@/components/Room/RoomDetailIconList'

type RoomFeatureListProps = {
  features: ApartmentFeatureId[]
}

export function RoomFeatureList({ features }: RoomFeatureListProps) {
  const copy = useMessages().roomDetail.features

  if (!features.length) {
    return null
  }

  return (
    <RoomDetailIconList aria-label={copy.ariaLabel}>
      {features.map((featureId) => {
        const Icon = apartmentFeatureIconComponents[featureId]
        const label = copy[featureId]

        return (
          <RoomDetailIconListItem
            key={featureId}
            icon={<Icon aria-hidden className="size-5 shrink-0 text-[#0B765A]" />}
          >
            {label}
          </RoomDetailIconListItem>
        )
      })}
    </RoomDetailIconList>
  )
}
